import type * as Types from "../../schema.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SaveTradeTaxDeclarationDraftPdfMutationVariables = Types.Exact<{
  email: Types.Scalars["String"];
  year: Types.Scalars["Int"];
}>;

export type SaveTradeTaxDeclarationDraftPdfMutation = {
  __typename?: "Mutation";
  saveTradeTaxDeclarationDraftPdf: {
    __typename?: "TradeTaxDeclarationProcessResult";
    pdf?: string | null;
    calculationSheet?: string | null;
    processResult: string;
    message: string;
  };
};

export const SaveTradeTaxDeclarationDraftPdfDocument = gql`
  mutation saveTradeTaxDeclarationDraftPdf($email: String!, $year: Int!) {
    saveTradeTaxDeclarationDraftPdf(email: $email, year: $year) {
      pdf
      calculationSheet
      processResult
      message
    }
  }
`;
export type SaveTradeTaxDeclarationDraftPdfMutationFn = Apollo.MutationFunction<
  SaveTradeTaxDeclarationDraftPdfMutation,
  SaveTradeTaxDeclarationDraftPdfMutationVariables
>;

/**
 * __useSaveTradeTaxDeclarationDraftPdfMutation__
 *
 * To run a mutation, you first call `useSaveTradeTaxDeclarationDraftPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTradeTaxDeclarationDraftPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTradeTaxDeclarationDraftPdfMutation, { data, loading, error }] = useSaveTradeTaxDeclarationDraftPdfMutation({
 *   variables: {
 *      email: // value for 'email'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useSaveTradeTaxDeclarationDraftPdfMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveTradeTaxDeclarationDraftPdfMutation,
    SaveTradeTaxDeclarationDraftPdfMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SaveTradeTaxDeclarationDraftPdfMutation,
    SaveTradeTaxDeclarationDraftPdfMutationVariables
  >(SaveTradeTaxDeclarationDraftPdfDocument, options);
}
export type SaveTradeTaxDeclarationDraftPdfMutationHookResult = ReturnType<
  typeof useSaveTradeTaxDeclarationDraftPdfMutation
>;
export type SaveTradeTaxDeclarationDraftPdfMutationResult =
  Apollo.MutationResult<SaveTradeTaxDeclarationDraftPdfMutation>;
export type SaveTradeTaxDeclarationDraftPdfMutationOptions =
  Apollo.BaseMutationOptions<
    SaveTradeTaxDeclarationDraftPdfMutation,
    SaveTradeTaxDeclarationDraftPdfMutationVariables
  >;
